import { render, staticRenderFns } from "./MyOverLay.vue?vue&type=template&id=3883232a"
import script from "./MyOverLay.vue?vue&type=script&lang=js"
export * from "./MyOverLay.vue?vue&type=script&lang=js"
import style0 from "./MyOverLay.vue?vue&type=style&index=0&id=3883232a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports